import ListsContainer from "../../components/uiKits/lists";

const Lists = () => {
  return <ListsContainer />;
};

export default Lists;
